import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { CARD_SETS, getCards } from "@/lib/cards";

export default function PrintCards() {
  const [params] = useSearchParams();
  const names = params.get("cards")?.split(",") || (params.get("card") ? [params.get("card")] : CARD_SETS.apology);
  const cards = getCards(names);

  useEffect(() => {
    const imgs = [...document.querySelectorAll(".pp-print-page img")];
    Promise.all(imgs.map((i) => (i.complete ? null : new Promise((r) => { i.onload = r; i.onerror = r; }))))
      .then(() => setTimeout(() => window.print(), 300));
  }, []);

  return (
    <div className="pp-print-sheet" data-testid="print-cards-page">
      {cards.map((c) => (
        <div key={c.name} className="pp-print-page"><img src={c.src} alt={c.alt} /></div>
      ))}
    </div>
  );
}
